import React from 'react';
import PropTypes from 'prop-types';

const Breadcrumbs = ({ breadcrumbs, onNavigateBreadcrumb, onNavigateHome }) => {
  const styles = {
    breadcrumbs: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap'
    },
    breadcrumbItem: {
      display: 'flex',
      alignItems: 'center'
    },
    breadcrumbLink: {
      color: '#374151',
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      padding: '0.2rem 0.5rem',
      borderRadius: '0.25rem',
      textDecoration: 'none',
      fontSize: '0.875rem',
      fontWeight: '500',
      transition: 'background-color 0.2s'
    },
    breadcrumbSeparator: {
      margin: '0 0.5rem',
      color: '#6B7280'
    }
  };

  return (
    <div style={styles.breadcrumbs}>
      <button 
        type="button"
        onClick={onNavigateHome}
        style={styles.breadcrumbLink}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#F3F4F6'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
      >
        Home
      </button>
      
      {breadcrumbs.map((crumb, index) => (
        <div key={crumb.id} style={styles.breadcrumbItem}>
          <span style={styles.breadcrumbSeparator}>/</span>
          <button 
            type="button"
            onClick={() => onNavigateBreadcrumb(crumb.id, crumb.name, index)}
            style={styles.breadcrumbLink}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#F3F4F6'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            {crumb.name}
          </button>
        </div>
      ))}
    </div>
  );
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  onNavigateBreadcrumb: PropTypes.func.isRequired,
  onNavigateHome: PropTypes.func.isRequired
};

export default Breadcrumbs;
